/**
 * Ouverture et fermeture douces des <details> de l'accordéon produit et de la FAQ.
 * Animation de la hauteur (Web Animations API) : fonctionne sur tous les navigateurs récents.
 * Sans JavaScript, ou si l'utilisateur demande moins d'animations, l'ouverture reste instantanée.
 */
(function () {
  'use strict';

  if (window.__kkDetailsAnim) return;
  window.__kkDetailsAnim = true;

  var SELECTOR = 'details.kk-accordion__row, details.kk-faq__item';
  var DURATION = 320;
  var EASING = 'cubic-bezier(0.22, 0.8, 0.24, 1)';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function finish(details, open) {
    details.open = open;
    details.classList.remove('kk-closing', 'kk-opening');
    details.style.removeProperty('overflow');
    details.style.removeProperty('box-sizing');
    details._kkAnimation = null;
  }

  function animate(details, from, to, opening) {
    if (details._kkAnimation) details._kkAnimation.cancel();

    // Les hauteurs mesurées incluent le padding et le filet : on anime donc en border-box (sinon la ligne « saute » au début et à la fin).
    details.style.overflow = 'hidden';
    details.style.boxSizing = 'border-box';
    details.classList.toggle('kk-closing', !opening);
    details.classList.toggle('kk-opening', opening);

    var animation = details.animate(
      { height: [from + 'px', to + 'px'] },
      { duration: DURATION, easing: EASING }
    );
    details._kkAnimation = animation;

    animation.onfinish = function () { finish(details, opening); };
    animation.oncancel = function () {
      details.style.removeProperty('overflow');
      details.style.removeProperty('box-sizing');
    };
  }

  document.addEventListener('click', function (event) {
    var target = event.target instanceof Element ? event.target : null;
    var summary = target ? target.closest('summary') : null;
    if (!summary) return;

    var details = summary.parentElement;
    if (!details || !details.matches(SELECTOR) || reduceMotion.matches) return;
    if (typeof details.animate !== 'function') return;

    event.preventDefault();

    var from = details.getBoundingClientRect().height;

    if (details.open && !details.classList.contains('kk-closing')) {
      // Fermeture : on mesure la hauteur « fermé » puis on revient à l'état ouvert pour animer.
      details.open = false;
      var closed = details.getBoundingClientRect().height;
      details.open = true;
      animate(details, from, closed, false);
    } else {
      // Ouverture (ou réouverture pendant une fermeture).
      details.open = true;
      var opened = details.getBoundingClientRect().height;
      animate(details, from, opened, true);
    }
  });
})();
